import { BsTools } from 'react-icons/bs'
import { BiCodeAlt } from 'react-icons/bi'
import { RiReactjsLine } from 'react-icons/ri'

export default function About() {
    return (
        <div>
            <h1 className='text-center my-6 mx-2 md:mt-0 md:mb-16 text-4xl font-bold'>My Technical Skills</h1>
            <section className="flex flex-col md:flex-row items-center">
                <div className="flex justify-center items-center text-center card bg-secondary p-6 my-2 md:mx-6 w-3/5 h-72 md:h-80 shadow-xl">
                    <BiCodeAlt className='h-10 w-10 md:h-14 md:w-14 text-accent-focus' />
                    <h3 className="font-bold text-xl md:text-2xl text-secondary-content my-4">Languages:</h3>
                    <ul className="ml-2 text-secondary-content md:text-lg">
                        <li>JavaScript</li>
                        <li>HTML</li>
                        <li>CSS</li>
                        <li>Python</li>
                        <li>SQL</li>
                    </ul>
                </div>
                <div className="flex justify-center items-center text-center card bg-secondary p-6 my-2 md:mx-6 w-4/5 md:w-3/5 h-72 md:h-96 shadow-xl">
                    <RiReactjsLine className='h-10 w-10 md:h-14 md:w-14 text-accent-focus' />
                    <h3 className="font-bold text-xl md:text-2xl text-secondary-content my-4">Frameworks:</h3>
                    <ul className="ml-2 text-secondary-content md:text-lg">
                        <li>React</li>
                        <li>Express.js</li>
                        <li>Mongoose</li>
                        <li>Django</li>
                        <li>Bootstrap</li>
                        <li>Tailwind CSS</li>
                    </ul>
                </div>
                <div className="flex justify-center items-center text-center card bg-secondary p-6 my-2 md:mx-6 w-3/5 h-72 md:h-80 shadow-xl">
                    <BsTools className='h-10 w-10 md:h-12 md:w-12 text-accent-focus' />
                    <h3 className="font-bold text-xl md:text-2xl text-secondary-content my-4">Tools:</h3>
                    <ul className="ml-2 text-secondary-content md:text-lg">
                        <li>Node.js</li>
                        <li>Heroku</li>
                        <li>AWS</li>
                        <li>Netlify</li>
                    </ul>
                </div>
            </section>
        </div>
    )
}